import React, { useEffect, useState } from "react";
import { Flex, Spin, Tag, Typography } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { GetRotableGroup } from "../redux/rotableThunk";
import { setFilteredGroup, setLoadingGroup, setSelectedGroup } from "../redux/rotableSlice";
import { GetRotableFleetGroup } from "../redux/rotableThunk";

const FilterRotGroup = () => {
    const groups = useSelector(state => state.rotableState.filteredGroup);
    const selectedTags = useSelector(state => state.rotableState.selectedGroup);
    const loadingGroup = useSelector(state => state.rotableState.loadingGroup);

    const dispatch = useDispatch();
    const { Text } = Typography;

    useEffect(() => {
        const params = {'fleet': []};
        const getGroupAction = GetRotableFleetGroup(params);
        dispatch(getGroupAction).unwrap().then((resp) => {               
        });
    },[]);

    const changeTag = (tag, checked) => {
        const nextSelectedTags = checked
        ? [...selectedTags, tag]
        : selectedTags.filter((t) => t !== tag);
        const setTagsAction =  setSelectedGroup(nextSelectedTags);
        dispatch(setTagsAction);     
    }

    return (
        <Flex vertical style={{gap:10, width:'98%', flexWrap:'wrap', maxHeight:'fit-content'}}>
            <Text style={{fontSize:'1.2rem', fontWeight:500}}>Equipment Group</Text>
            <Spin spinning={loadingGroup}>
                <Flex style={{width:'98%', flexWrap:"wrap", gap:8}}>
                {
                    groups.map((g)=>{
                    return  (
                        <Tag.CheckableTag
                            checked={selectedTags.includes(g.MatGroup)}
                            onChange={(checked)=>changeTag(g.MatGroup,checked)}
                            style={{border: '1px solid #E5E7EB', background: selectedTags.includes(g.MatGroup)?'#3f076c':'rgba(255,255,255,0.9)', fontSize:13, borderRadius:20, marginTop:7,paddingTop:8,paddingBottom:8,paddingLeft:15,paddingRight:15,fontWeight:500}}                        
                        >
                            {g.MatGroup}
                        </Tag.CheckableTag>
                    )
                    })
                }
                </Flex>
            </Spin>
        </Flex>
    )
}

export default FilterRotGroup;